<template>
  <v-container
    class="my-12"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-flex
              xs12
              class="text-center"
            >
              <v-icon
                x-large
                class="blue--text text--darken-2"
              >
                mdi-email
              </v-icon>
              <div
                v-if="wasEmailSend"
                class="display-1"
              >
                Bestätigungs-Code eingeben:
              </div>
              <div
                v-else
                class="display-1"
              >
                Bestätigungs E-Mail erneut senden:
              </div>
            </v-flex>
          </v-card-title>

          <v-card-text v-if="wasEmailSend">
            <p class="text-center">
              Deine Bestätigungs E-Mail wurde versand.<br>Schau in Deinem Postfach oder Spamordner nach und gebe den Code hier ein:
            </p>
            <v-text-field
              v-model="verificationToken"
              prepend-icon="mdi-email"
              type="text"
              name="Bestätigungscode"
              label="Bestätigungscode eingeben"
              required
            />

            <my-alert
              v-if="this.$store.state.error"
              :error="this.$store.state.error"
              :title="this.$store.state.errorTitle"
              type="error"
            />
            <v-card-actions>
              <v-btn
                :loading="this.$store.state.loading"
                outlined
                large
                block
                class="primary--text"
                @click.native.stop="sendVerificationToken()"
              >
                Code bestätigen <v-icon right class="blue--text text--darken-2">
                  mdi-send
                </v-icon>
              </v-btn>
            </v-card-actions>
            <br>
            <br>
            <v-col
              v-if="showResendButton"
              class="text-center"
            >
              <v-btn
                :loading="this.$store.state.loading"
                outlined
                @click.native.stop="sendEmail()"
              >
                Keine E-Mail erhalten? Email erneut senden
                <v-icon
                  right
                  class="blue--text text--darken-2"
                >
                  mdi-send
                </v-icon>
              </v-btn>
            </v-col>
          </v-card-text>

          <v-card-text v-else>
            <v-text-field
              :rules="emailRules"
              :error-messages="errorMessageEmail"
              v-model="email"
              prepend-icon="mdi-email"
              type="email"
              name="E-Mail"
              label="E-Mail-Adresse"
              required
            />

            <my-alert
              v-if="this.$store.state.error"
              :error="this.$store.state.error"
              :title="this.$store.state.errorTitle"
              type="error"
            />
            <v-card-actions>
              <v-btn
                :loading="this.$store.state.loading"
                outlined
                large
                block
                class="primary--text"
                @click.native.stop="sendEmail()"
              >
                E-Mail erneut senden <v-icon right class="blue--text text--darken-2">
                  mdi-send
                </v-icon>
              </v-btn>
            </v-card-actions>
            <br>
            <p class="text-center">
              <router-link to="/register">
                Neu hier? Dann registriere Dich hier kostenlos für den Kegelmanager!
              </router-link>
            </p>
            <p class="text-center">
              <router-link to="/new-password">
                Passwort vergessen? Dann hier ein neues anfordern.
              </router-link>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'
const emailCheck = require('../../vendor/checkEmail')

export default {
  name: 'Emailactivation',
  metaInfo: {
    title: 'Email-Activation'
  },
  data () {
    return {
      email: '',
      emailRules: [],
      wasEmailSend: false,
      verificationToken: '',
      showResendButton: false,
      errorMessageEmail: []
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.loggedIn || this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
    this.email = this.$store.state.loginRegisterStore.loginEmail
    this.wasEmailSend = this.$store.state.loginRegisterStore.wasVerifyEmailSend
    if (this.wasEmailSend) {
      const self = this
      setTimeout(() => { self.showResendButton = true }, 20000)
    }
  },
  methods: {
    validateAll: (email) => {
      const ret = { status: true }
      if (!emailCheck(email)) {
        ret.email = true
        ret.status = false
      }
      return ret
    },
    sendEmail: async function () {
      this.showResendButton = false
      this.$store.commit(ROOT_LOADING, true)
      const check = this.validateAll(this.email)
      this.emailRules = []
      this.errorMessageEmail = []
      if (!check.status) {
        // show errors
        if (check.email) {
          this.emailRules = this.errorMessageEmail = ['Fehlerhafte E-Mail-Adresse!']
        }

        this.$store.commit(ROOT_LOADING, false)
        return false
      }

      const wasSend = await this.$store.dispatch('loginRegisterStore/sendActivationMail', this.email)
      if (wasSend) {
        // show E_Mail gesendet
        this.wasEmailSend = true
        // show nach 20 secunden den button
        var self = this
        setTimeout(() => { self.showResendButton = true }, 20000)
      }
    },
    sendVerificationToken: async function () {
      this.showResendButtonElement = false
      this.$store.commit(ROOT_LOADING, true)

      const sendVerifyToken = await this.$store.dispatch('loginRegisterStore/sendVerificationToken', {
        token: this.verificationToken,
        email: this.email
      })
      if (sendVerifyToken && this.$store.state.loggedIn) {
        this.$router.replace({ path: '/buero' })
      }
    }
  }
}
</script>
